import { get } from 'lodash/fp';
import { createPrefixer } from '@mews-commander/utils';
import module from './module';

const moduleName = 'preferences';

export default {
    moduleName,
    ...module({
        moduleSelector: get(moduleName),
        prefix: createPrefixer(moduleName),
    }),
};
